export default __webpack_public_path__ + "static/media/Logo.02a9ec4d.svg";